import {isObject} from '@utils/isObject'
import {IApplicationDefinition, IAppRegistry} from '@apps-config/app-definition'
import {RoutesHelper} from '@apps-config/routing/routing'
import {Activity} from '@utils/activity-tracking'
import {ApplicationName as YourProductsAndServicesTrackingApplicationName} from '@telstra-connect/your-products-and-services/activity-tracking'
import type {IServicePerformanceAppState} from '@telstra-connect/service-performance/state'
import {performanceReducer as ServicePerformanceReducers} from '@telstra-connect/service-performance/reducers'
import {secureRouteBuilder} from '@applications/secure-route'
import Routes from '@applications/service-performance/route-constants'
import YPSSurfaceContainer from './components/dashboard-int/int-surface-container-lazy'
import {IUserProfile} from '@telstra-connect/login/state'
import {getServicePerformanceFlagName} from '@applications'
import {IAuthorizedRequestState} from '@telstra-connect/utils/http/requests/request'
import {getCompanyIdInit, isInternationalCustomer} from '@telstra-connect/config/config'
import GlobalNetworksDetails from './pages/global-networks-details-int/index-lazy'

const routes = new RoutesHelper({
  rootPath: secureRouteBuilder(`${Routes.ServicePerformance}/${Routes.PerformanceStatus}`),
  subpagesPathMask: secureRouteBuilder(Routes.ServicePerformance),
})

export const servicePerformanceRoute = routes.getAppPath()

export const applicationName = YourProductsAndServicesTrackingApplicationName

const tracker = Activity.createTracker(applicationName)

export function SPMDisplayName() {
  // FIXME: window['applications'] is used as global object need to pass this a param
  // pass this a to MFE's and other subapplications platform
  // eslint-disable-next-line dot-notation,@typescript-eslint/dot-notation
  const servicesConfig = window['applications']
  if (servicesConfig && isObject(servicesConfig[applicationName])) {
    return servicesConfig[applicationName].displayName
  }
  return ''
}

export function isSPMAvailable() {
  // FIXME: window['applications'] is used as global object need to pass this a param
  // pass this a to MFE's and other subapplications platform
  // eslint-disable-next-line dot-notation,@typescript-eslint/dot-notation
  const servicesConfig = window['applications']
  if (servicesConfig == null) {
    return false
  }
  if (isObject(servicesConfig[applicationName])) {
    return true
  }
  return false
}

export const Application: IApplicationDefinition = {
  get applicationName() {
    return applicationName
  },

  get acceptsUserFeedback() {
    return true
  },

  get acceptsErrorReports() {
    return true
  },

  get card() {
    return YPSSurfaceContainer
  },

  get tracker() {
    return tracker
  },

  get routes() {
    return routes
  },

  init(
    registry: IAppRegistry,
    availableToUser: boolean,
    userProfile: IUserProfile,
    authorizedRequestState: IAuthorizedRequestState,
  ) {
    const companyId = getCompanyIdInit(userProfile, authorizedRequestState)
    const isInternational = isInternationalCustomer(companyId)
    if (isInternational && getServicePerformanceFlagName('yourProductsAndServicesInternational')) {
      registry.add(Application)
    }
  },

  render() {
    return [
      {
        path: routes.getPageSubpath(Routes.AdaptiveNetworksDetailInt),
        component: GlobalNetworksDetails,
      },
    ]
  },

  menuItem(state, navigate) {
    return []
  },
}

export {ServicePerformanceReducers, IServicePerformanceAppState, Routes}
